export const ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;

export const normalizeZip = (value: string): string => {
  return value.trim();
};

export const getZip5 = (value: string): string => {
  const normalized = normalizeZip(value);
  const match = normalized.match(/^(\d{5})/);
  return match ? match[1] : '';
};

export const isValidZipFormat = (value: string): boolean => {
  return ZIP_CODE_REGEX.test(normalizeZip(value));
};

export const isRealUsZip = (value: string, validZips: Set<string>): boolean => {
  const zip5 = getZip5(value);
  return validZips.has(zip5);
};